<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/v3/7foreword#foreword">Foreword: “Edward Whittemore (1933–1995)” by Tom Wallace</a></p>
<h3 class="center"><a href="#/v1/1cover">Sinai Tapestry</a></h3>
<p class="toc1" style="margin-top:20px;"><a href="#/v1/10chap2#chap2">Part One</a></p>
<p class="toc2"><a href="#/v1/11chap3#chap3">1. Strongbow</a></p>
<p class="toc2"><a href="#/v1/12chap4#chap4">2. Wallenstein</a></p>
<p class="toc2"><a href="#/v1/13chap5#chap5">3. Cairo 1840</a></p>
<p class="toc2"><a href="#/v1/14chap6#chap6">4. Sinai 1836–1843</a></p>
<p class="toc2"><a href="#/v1/15chap7#chap7">5. The Haj</a></p>
<p class="toc2"><a href="#/v1/16chap8#chap8">6. YHWH</a></p>
<p class="toc2"><a href="#/v1/17chap9#chap9">7. The Tiberias Telegrams</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/v1/18chap10#chap10">Part Two</a></p>
<p class="toc2"><a href="#/v1/19chap11#chap11">8. O’Sullivan Beare</a></p>
<p class="toc2"><a href="#/v1/20chap12#chap12">9. Haj Harun</a></p>
<p class="toc2"><a href="#/v1/21chap13#chap13">10. The Scarab</a></p>
<p class="toc2"><a href="#/v1/22chap14#chap14">11. Maud</a></p>
<p class="toc2"><a href="#/v1/23chap15#chap15">12. Aqaba</a></p>
<p class="toc2"><a href="#/v1/24chap16#chap16">13. Jericho</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/v1/25chap17#chap17">Part Three</a></p>
<p class="toc2"><a href="#/v1/26chap18#chap18">14. Stern</a></p>
<p class="toc2"><a href="#/v1/27chap19#chap19">15. The Jordan</a></p>
<p class="toc2"><a href="#/v1/28chap20#chap20">16. Jerusalem 700 B.C.–1932</a></p>
<p class="toc2"><a href="#/v1/29chap21#chap21">17. The Bosporua</a></p>
<p class="toc2"><a href="#/v1/30chap22#chap22">18. Melchizedek 220 B.C.–1933</a></p>
<p class="toc2"><a href="#/v1/31chap23#chap23">19. Athens</a></p>
<p class="toc2"><a href="#/v1/32chap24#chap24">20. Smyrna 1922</a></p>
<p class="toc2"><a href="#/v1/33chap25#chap25">21. Cairo 1942</a></p>
<h3 class="center"><a href="#/v3/1cover">Jerusalem Poker</a></h3>
<p class="toc1"><a href="#/v3/8chap1#chap1">Introduction by Lesley Hazleton</a></p>
<p class="toc1"><span href="#/v3/prologue" title="Link target outside of Sample">Prologue</span></p>
<p class="toc1" style="margin-top:20px;"><a href="#/v3/9chap2#chap2">Part One</a></p>
<p class="toc2"><a href="#/v3/10chap3#chap3">1. Jerusalem 1933</a></p>
<p class="toc2"><a href="#/v3/11chap4#chap4">2. Cairo Martyr</a></p>
<p class="toc2"><a href="#/v3/12chap5#chap5">3. Cheops’ Pyramid</a></p>
<p class="toc2"><a href="#/v3/13chap6#chap6">4. Solomon’s Quarries</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/v3/14chap7#chap7">Part Two</a></p>
<p class="toc2"><a href="#/v3/15chap8#chap8">5. Munk Szondi</a></p>
<p class="toc2"><a href="#/v3/16chap9#chap9">6. St. Catherine’s Monastery</a></p>
<p class="toc2"><a href="#/v3/17chap10#chap10">7. Haj Harun</a></p>
<p class="toc2"><a href="#/v3/18chap11#chap11">8. Joker Wild</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/v3/19chap12#chap12">Part Three</a></p>
<p class="toc2"><a href="#/v3/20chap13#chap13">9. Nubar Wallenstein</a></p>
<p class="toc2"><a href="#/v3/21chap14#chap14">10. Sophia the Black Hand</a></p>
<p class="toc2"><a href="#/v3/22chap15#chap15">11. Gronk</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/v3/23chap16#chap16">Part Four</a></p>
<p class="toc2"><a href="#/v3/24chap17#chap17">12. Maud</a></p>
<p class="toc2"><a href="#/v3/25chap18#chap18">13. O’Sullivan Beare</a></p>
<p class="toc2"><a href="#/v3/26chap19#chap19">14. Stern</a></p>
<p class="toc2"><a href="#/v3/27chap20#chap20">15. Sheik Ibrahim ibn Harun</a></p>
<p class="toc2"><a href="#/v3/28chap21#chap21">16. Venice 1933</a></p>
<p class="toc2"><a href="#/v3/29chap22#chap22">17. Crypt, Cobbler</a></p>
<p class="toc2"><a href="#/v3/30chap23#chap23">18. Bernini</a></p>
<h3 class="center"><a href="#/v2/1cover">Nile Shadows</a></h3>
<p class="toc2"><a href="#/v2/8chap1#chap1">“Nile Shadows: The Improbable Art of Edward Whittemore” by Ben Gibberd</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/v2/9chap2#chap2">Part One</a></p>
<p class="toc2"><a href="#/v2/10chap3#chap3">1. An Australian Hand Grenade</a></p>
<p class="toc2"><a href="#/v2/11chap4#chap4">2. The Purple Seven Armenian</a></p>
<p class="toc2"><a href="#/v2/12chap5#chap5">3. Hopi Mesa Kiva</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/v2/13chap6#chap6">Part Two</a></p>
<p class="toc2"><a href="#/v2/14chap7#chap7">4. Vivian</a></p>
<p class="toc2"><a href="#/v2/15chap8#chap8">5. Liffy</a></p>
<p class="toc2"><a href="#/v2/16chap9#chap9">6. Sphinx</a></p>
<p class="toc2"><a href="#/v2/17chap10#chap10">7. Monastery</a></p>
<p class="toc2"><a href="#/v2/18chap11#chap11">8. Maud</a></p>
<p class="toc2"><a href="#/v2/19chap12#chap12">9. Menelik</a></p>
<p class="toc2"><a href="#/v2/20chap13#chap13">10. Ahmad</a></p>
<p class="toc2"><a href="#/v2/21chap14#chap14">11. Trombone</a></p>
<p class="toc2"><a href="#/v2/22chap15#chap15">12. Beggar</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/v2/23chap16#chap16">Part Three</a></p>
<p class="toc2"><a href="#/v2/24chap17#chap17">13. Cohen</a></p>
<p class="toc2"><a href="#/v2/25chap18#chap18">14. Bletchley</a></p>
<p class="toc2"><a href="#/v2/26chap19#chap19">15. The Sisters</a></p>
<p class="toc2"><a href="#/v2/27chap20#chap20">16. Two Candles</a></p>
<p class="toc2"><a href="#/v2/28chap21#chap21">17. Mementos</a></p>
<p class="toc2"><a href="#/v2/29chap22#chap22">18. Crypt/Mirror</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/v2/30chap23#chap23">Part Four</a></p>
<p class="toc2"><a href="#/v2/31chap24#chap24">19. A Golden Bell and a Pomegranate</a></p>
<p class="toc2"><a href="#/v2/32chap25#chap25">20. A Gift of Faces, a Gift of Tongues</a></p>
<p class="toc2"><a href="#/v2/33chap26#chap26">21. Purple Seven Moonlight</a></p>
<p class="toc2"><a href="#/v2/34chap27#chap27">22. Bernini’s Bag</a></p>
<p class="toc2"><a href="#/v2/35chap28#chap28">23. Nile Echoes</a></p>
<h3 class="center"><a href="#/v4/1cover">Jericho Mosaic</a></h3>
<p class="toc1"><a href="#/v4/8chap1#chap1">Introduction by James Hougan</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/v4/9chap2#chap2">Part One</a></p>
<p class="toc2" style="margin-top:20px;"><a href="#/v4/10chap3#chap3">1</a></p>
<p class="toc2"><a href="#/v4/11chap4#chap4">2</a></p>
<p class="toc2"><a href="#/v4/12chap5#chap5">3</a></p>
<p class="toc2"><a href="#/v4/13chap6#chap6">4</a></p>
<p class="toc2"><a href="#/v4/14chap7#chap7">5</a></p>
<p class="toc2"><a href="#/v4/15chap8#chap8">6</a></p>
<p class="toc2"><a href="#/v4/16chap9#chap9">7</a></p>
<p class="toc2"><a href="#/v4/17chap10#chap10">8</a></p>
<p class="toc2"><a href="#/v4/18chap11#chap11">9</a></p>
<p class="toc2"><a href="#/v4/19chap12#chap12">10</a></p>
<p class="toc2"><a href="#/v4/20chap13#chap13">11</a></p>
<p class="toc2"><a href="#/v4/21chap14#chap14">12</a></p>
<p class="toc2"><a href="#/v4/22chap15#chap15">13</a></p>
<p class="toc2"><a href="#/v4/23chap16#chap16">14</a></p>
<p class="toc2"><a href="#/v4/24chap17#chap17">15</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/v4/25chap18#chap18">Part Two</a></p>
<p class="toc2" style="margin-top:20px;"><a href="#/v4/26chap19#chap19">1</a></p>
<p class="toc2"><a href="#/v4/27chap20#chap20">2</a></p>
<p class="toc2"><a href="#/v4/28chap21#chap21">3</a></p>
<p class="toc2"><a href="#/v4/29chap22#chap22">4</a></p>
<p class="toc2"><a href="#/v4/30chap23#chap23">5</a></p>
<p class="toc2"><a href="#/v4/31chap24#chap24">6</a></p>
<p class="toc2"><a href="#/v4/32chap25#chap25">7</a></p>
<p class="toc2"><a href="#/v4/33chap26#chap26">8</a></p>
<p class="toc2"><a href="#/v4/34chap27#chap27">9</a></p>
<p class="toc2"><a href="#/v4/35chap28#chap28">10</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/v4/36chap29#chap29">Part Three</a></p>
<p class="toc2" style="margin-top:20px;"><a href="#/v4/37chap30#chap30">1</a></p>
<p class="toc2"><a href="#/v4/38chap31#chap31">2</a></p>
<p class="toc2"><a href="#/v4/39chap32#chap32">3</a></p>
<p class="toc2"><a href="#/v4/40chap33#chap33">4</a></p>
<p class="toc2"><a href="#/v4/41chap34#chap34">5</a></p>
<p class="toc2"><a href="#/v4/42chap35#chap35">6</a></p>
<p class="toc2"><a href="#/v4/43chap36#chap36">7</a></p>
<p class="toc2"><a href="#/v4/44chap37#chap37">8</a></p>
<p class="toc2"><a href="#/v4/45chap38#chap38">9</a></p>
<p class="toc2"><a href="#/v4/46chap39#chap39">10</a></p>
<p class="toc2"><a href="#/v4/47chap40#chap40">11</a></p>
<p class="toc2"><a href="#/v4/48chap41#chap41">12</a></p>
<p class="toc2"><a href="#/v4/49chap42#chap42">13</a></p>
<p class="toc2"><a href="#/v4/50chap43#chap43">14</a></p>
<p class="toc2"><a href="#/v4/51chap44#chap44">15</a></p>
<p class="toc2"><a href="#/v4/52chap45#chap45">16</a></p>
<p class="toc2" style="margin-top:20px;"><a href="#/v4/53chap46#chap46">An Editorial Relationship</a></p>
<p class="toc2" style="margin-top:20px;"><a href="#/v4/54biography">About the Author</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3-TOC.vue?271092f5